import React, { useState, useEffect, useRef } from 'react';
import * as LucideIcons from 'lucide-react';

import { useAppContext } from '../AppContext';

const ReactionBar = ({ chatId, message, onReact, isUser }) => {
    const { userId } = useAppContext();
    const [pickerVisible, setPickerVisible] = useState(false);
    const pickerRef = useRef(null);

    const availableEmojis = ['❤️', '😂', '👍', '😢', '🔥'];
    const reactions = message.reactions || {};

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (pickerRef.current && !pickerRef.current.contains(event.target)) {
                setPickerVisible(false);
            }
        };
        if (pickerVisible) document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [pickerVisible]);

    return (
        <div className={`relative flex items-center gap-1 mt-1 ${isUser ? 'justify-end' : 'justify-start'}`}>
            {Object.entries(reactions).map(([emoji, userIds]) => {
                if (userIds && userIds.length > 0) {
                    const userHasReacted = userIds.includes(userId);
                    return (
                        <button
                            key={emoji}
                            onClick={() => onReact(chatId, message.id, emoji)}
                            className={`px-2 py-0.5 rounded-full flex items-center gap-1 text-xs transition-colors ${userHasReacted ? 'bg-blue-600 border border-blue-400 text-white' : 'bg-gray-600/50 border border-transparent hover:bg-gray-500/50'}`}
                        >
                            <span>{emoji}</span>
                            <span className="font-semibold">{userIds.length}</span>
                        </button>
                    );
                }
                return null;
            })}

            <div className="relative" ref={pickerRef}>
                <button onClick={() => setPickerVisible(p => !p)} className="p-1 rounded-full text-gray-400 hover:bg-white/10 hover:text-white">
                    <LucideIcons.SmilePlus size={16} />
                </button>
                {pickerVisible && (
                    <div className={`absolute bottom-full mb-2 p-1 bg-gray-900 border border-gray-700 rounded-full flex gap-1 ${isUser ? 'right-0' : 'left-0'}`}>
                        {availableEmojis.map(emoji => (
                            <button
                                key={emoji}
                                onClick={() => { onReact(chatId, message.id, emoji); setPickerVisible(false); }}
                                className="p-1.5 rounded-full hover:bg-blue-600/50 transition-transform hover:scale-125"
                            >
                                {emoji}
                            </button>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default ReactionBar;